import { HelpersService } from './../../services/tools/helpers.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from './../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import { ProveedoresService } from '../../services/proveedores.service';
import { CatalogosSatService } from '../../services/catalogos-sat-service';
import {ValidatorService} from "../../services/tools/validator.service";
import {Globals} from './../../services/tools/Globals.service';
declare var jquery;
declare var $;

@Component({
  selector: 'app-catalogo-proveedores',
  templateUrl: './catalogo-proveedores.component.html',
  styleUrls: ['./catalogo-proveedores.component.scss']
})
export class CatalogoProveedoresComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  proveedores:any[];
  searchText:string = "";
  proveedorSelected:any;
  proveedorChecked:any;
  mostrarListado:boolean = true;
  errors:any = {};
  searchProcess:any;
  statuses:any = {};
  paginate:any = {};
  tiposProveedor:any[];
  tiposRegimen:any[];
  currentPage: any = 1;
  lastPage: any = 1;
  processing:any = false;
  alterTable:any = 'starting';
  exporting: any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor(  private proveedoresService: ProveedoresService,
                private catalogosSatService: CatalogosSatService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private globals: Globals) {
    this.habilitar = this.habilitar.bind(this);
  }

  ngOnInit() {
    this.getProveedores();
    this.getTiposProveedor();
    this.getTiposRegimen();
    this.deleteProveedor = this.deleteProveedor.bind(this);
    this.resetProveedorSelected = this.resetProveedorSelected.bind(this);
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  resetProveedorSelected(){
    this.proveedorSelected = undefined;
    this.errors = {};
  }

  startProveedorSelected(){
    this.resetProveedorSelected();
    this.proveedorSelected = this.proveedoresService.getDefaultSchedule();
  }

  selectProveedor( proveedor ){
    this.resetProveedorSelected();
    const proveedorCloned = JSON.parse(JSON.stringify( proveedor ));
    this.proveedorSelected = proveedorCloned;
    console.log("this.proveedorSelected: ",this.proveedorSelected);
  }

  SelectedProveedorClass(proveedor){
    return (this.validatorService.required(this.proveedorSelected) &&  this.proveedorSelected.idProveedores == proveedor.idProveedores)?"active":"";
  }

  confirmdeleteProveedor(){
    this.confirmModal.open({
      'title': 'Eliminar Proveedor',
      'description': '¿Está seguro que desea eliminar este Proveedor?',
      'callback': this.deleteProveedor
    });
  }

  deleteProveedor(){
    this.processing = true;
    this.proveedoresService.deleteProveedor(this.proveedorSelected.idProveedores)
      .subscribe(
        response => {
          this.processing = false;
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha eliminado correctamente el proveedor seleccionado'
          });

          this.getProveedores();
      },error => {
          this.processing = false;
          // resolviendo errores 403 y 500
          this.helperService.httpGlobalError(error);
      });
  }

  searchProveedor(page = null){
    if(this.searchProcess){
      this.searchProcess.unsubscribe();
    }
    if(this.searchText.length > 1){
      this.searchProcess = this.proveedoresService.searchProveedores(this.searchText, page)
          .subscribe(response => {
            let content = response.json().content;
            this.proveedores = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.proveedores.length > 0)? false: 'not_found';
          });
    }else{
      this.getProveedores();
    }
  }

  getTiposProveedor(){
    this.proveedoresService.getTiposProveedor()
      .subscribe(response => {
        let content = response.json().content;
        this.tiposProveedor = content;
      });
  }

  getTiposRegimen(){
    this.catalogosSatService.getSatRegimenFiscal()
      .subscribe(response => {
        let content = response.json().content;
        this.tiposRegimen = content;
      });
  }

  getProveedores(page = null){
    this.searchProcess = this.proveedoresService.getProveedores(page)
      .subscribe(response => {
        let content = response.json().content;
        this.proveedores = content.data;
        this.startPaginate(content);
        this.alterTable = (this.proveedores.length > 0)? false: 'not_result';
        this.searchProcess = false;
      });
  }

  createProveedor(){
    this.errors = [];
    this.errors = this.proveedoresService.validateProveedor(this.proveedorSelected)

    if(!$.isEmptyObject(this.errors)){
      return false;
    }
    this.processing = true;
    this.proveedorSelected.activo = (this.proveedorSelected.activo)?1:0;
    this.proveedorSelected.idTipo_Proveedor = this.proveedorSelected.tipo_proveedor.idTipo_Proveedor;
    this.proveedorSelected.sat_regimen_fiscal_id = this.proveedorSelected.regimen_fiscal.sat_regimen_fiscal_id;
    console.log("this.proveedorSelected: ",this.proveedorSelected);

    this.proveedoresService.createProveedor(this.proveedorSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el proveedor'
          });
          this.proveedorSelected.idProveedores = respuesta.content.id;
          this.goPage(1);
        }
      }, error => {
        this.processing = false;
        // resolviendo errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 400 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el proveedor, inténtelo más tarde'
          });
        }
      });
  }

  updateProveedor(){
    this.errors = [];
    this.errors = this.proveedoresService.validateProveedor(this.proveedorSelected)
    if(!$.isEmptyObject(this.errors)){
      return false;
    }

    this.processing = true;
    this.proveedorSelected.activo = (this.proveedorSelected.activo)?1:0;
    this.proveedorSelected.idTipo_Proveedor = this.proveedorSelected.tipo_proveedor.idTipo_Proveedor;
    this.proveedorSelected.sat_regimen_fiscal_id = this.proveedorSelected.regimen_fiscal.sat_regimen_fiscal_id;
    console.log("this.proveedorSelected: ",this.proveedorSelected);

    this.proveedoresService.updateProveedor(this.proveedorSelected, this.proveedorSelected.idProveedores)
      .subscribe(response => {
        this.processing = false;
        if(response.json().success){
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el proveedor', 'success');
          this.goPage(this.currentPage);
        }
      }, error => {
        this.processing = false;

        // resolviendo errores 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notificationErrorDefault();
        }
      });
  }

  setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  writePermission() {
    return this.proveedoresService.writePermission();
  }

  canExport() {
    return this.proveedoresService.canExport();
  }

  proveedorSelectedWithId() {
    if (! this.proveedorSelected)
      return false;

    return (this.proveedorSelected.idProveedores);
  }

  confirmHabilitar(proveedor) {
    this.proveedorChecked = proveedor;

    const title = (this.proveedorChecked.activo == 1) ? 'Desactivar' : 'Activar';
    const body = (this.proveedorChecked.activo == 1) ? 'desactivará' : 'activará';

    this.confirmModal.open({
      'title': title + ' el proveedor',
      'description': 'El siguiente proveedor se ' + body + ': ' + this.proveedorChecked.nombre,
      'callback': this.habilitar
    });

    return false;
  }
  habilitar() {
    const title = (this.proveedorChecked.activo == 1) ? 'desactivado' : 'activado';
    this.proveedoresService.updateProveedor(this.proveedorChecked, this.proveedorChecked.idProveedores)
        .subscribe( response => {
          if (response.json().success) {
            this.helperService.notification('¡Éxito!', 'Se ha ' + title + '  el proveedor', 'success');
            this.proveedorChecked.activo = (this.proveedorChecked.activo == 1) ? 0 : 1;
          }
        }, error => {
          // resolviendo errores 403 y 500
          this.helperService.httpGlobalError(error);
          if (error.status == 400) {
            this.setBackendErrors(error.json().content);
            this.helperService.notificationErrorDefault();
          }
        });
  }

  cancelarProveedorSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetProveedorSelected
    });
  }

  // MODAL FUNCTIONS

  modalCallback(callback){
    callback();
  }

  // MAIN SECTIONS FUNCTIONS 

  mainContainerClass(){
    return (this.mostrarListado)?"col-12":"offset-2 col-8";
  }

  mainTableClass(){
    return (this.mostrarListado)?"col-8":"col-4";
  }

  mainDetailsClass(){
    return (this.mostrarListado)?"col-4":"col-8";
  }

  startPaginate(content){
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for(let i = 1; i <= this.paginate.last_page; i++){
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage(){
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage(){
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page){

    if(this.searchText){
      this.searchProveedor(page);
    } else {
      this.getProveedores(page);
    }
  }

  changeSwitchListado(){
    if(!this.mostrarListado){
      this.proveedorSelected = this.proveedoresService.getDefaultSchedule();
    }
  }

  export() {
    this.exporting = true;
    this.proveedoresService.export(this.searchText)
      .subscribe((response) => {
        this.exporting = false;
      }, error => {
        // se resuelven los errores 403 y 500
        this.exporting = false;
        this.helperService.httpGlobalError(error);
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-proveedores/catalogo-proveedores.component.ts